import { render, staticRenderFns } from "./warningRelease.vue?vue&type=template&id=e48d75b4&scoped=true&"
import script from "./warningRelease.vue?vue&type=script&lang=js&"
export * from "./warningRelease.vue?vue&type=script&lang=js&"
import style0 from "./warningRelease.vue?vue&type=style&index=0&id=e48d75b4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48d75b4",
  null
  
)

export default component.exports